import type { ComponentType } from 'react';

import { Card, Typography } from 'antd';

type IconComponent = ComponentType<{ className?: string; size?: number | string }>;

type ButtonProps = {
  id: string;
  title: string;
  subtitle: string;
  onClick?: () => void;
  icon: IconComponent;
  isNew?: boolean;
};

export const ButtonRedirect = ({ id, onClick, title, subtitle, icon: ProductIcon }: ButtonProps) => {
  return (
    <Card
      id={id}
      onClick={onClick}
      className='h-full min-h-35 cursor-pointer rounded-lg shadow-none transition-[background-color,border-color] duration-200 hover:border-(--uizz-antd-color-primary) hover:bg-(--uizz-antd-color-primary-bg) hover:shadow-none'
      classNames={{ body: 'h-full p-4' }}
    >
      <div className='flex h-full flex-col gap-3 text-left'>
        <ProductIcon className='size-7 text-(--uizz-antd-color-primary)' size={28} />
        <div className='flex flex-col gap-1'>
          <Typography.Text strong className='text-base'>
            {title}
          </Typography.Text>
          <Typography.Text type='secondary' className='text-sm'>
            {subtitle}
          </Typography.Text>
        </div>
      </div>
    </Card>
  );
};
